module.exports = __webpack_public_path__ + "img/logowzry.87b48660.png";